import layout from '@/layout'

export default {
  path: '/winner',
  component: layout,
  redirect: '/winner/open',
  name: 'winner_open',
  meta: {
    title: 'winner',
    icon: 'winner'
  },
  children: [
    {
      path: '/winner/open',
      name: 'winner_open',
      component: () => import('@/views/winner/pages/winner_open/index.vue'),
      meta: {
        title: 'winner_open',
        icon: 'bang'
      }
    },
    {
      path: '/winner/mark',
      name: 'winner_open_mark',
      component: () => import('@/views/winner/pages/winner_mark/index.vue'),
      meta: {
        title: 'winner_open_mark',
        icon: 'bang'
      }
    }
  ]
}
